import React from "react";
import { Title } from "../../components/Title";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { Link } from "../../components/Link";

export const CognitoDeploy = () => {
  const { t } = useTranslation();
  return (
    <div className="cognito-deploy">
      <section>
        <div className="inner">
          <Title title={t("solution.cognito.deploy.title")}>
            {t("solution.cognito.deploy.subtitle1")}
            <span style={{ margin: "0px 4px" }}>
              <Link href="https://github.com/aws-samples/aws-authing-demo" rel="noopener noreferrer" target="_blank">
                https://github.com/aws-samples/aws-authing-demo
              </Link>
            </span>
            {t("solution.cognito.deploy.subtitle2")}
          </Title>
          <div className="deploy-item">
            <div>
              <div className="item-img">
                <img src="//files.authing.co/authing-website/solution-cognito-callback.png" alt="authing cognito" />
              </div>
              <div className="item-img-text">{t("solution.cognito.deploy.item1.imgText")}</div>
            </div>
            <div className="item-text" style={{ width: 600 }}>
              <div className="title">{t("solution.cognito.deploy.item1.title")}</div>
              <div className="descript">
                {t("solution.cognito.deploy.item1.subtitle1")}
                <span style={{ margin: "0px 4px" }}>
                  <Link
                    href="https://docs.authing.cn/v2/guides/federation/oidc.html"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {t("solution.cognito.deploy.item1.link")}
                  </Link>
                </span>
                {t("solution.cognito.deploy.item1.subtitle2")}
              </div>
            </div>
          </div>
          <div className="deploy-item">
            <div className="item-text" style={{ width: "100%" }}>
              <div className="title">{t("solution.cognito.deploy.item2.title")}</div>
              <div className="descript">
                {t("solution.cognito.deploy.item2.subtitle1")}
                <span style={{ margin: "0px 4px" }}>
                  <Link
                    href="https://docs.authing.cn/v2/guides/federation/oidc.html"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    {t("solution.cognito.deploy.item1.link")}
                  </Link>
                </span>
                {t("solution.cognito.deploy.item2.subtitle2")}
              </div>
              <div className="linux-code" style={{ width: 90, marginBottom: 10 }}>
                $ sam build
              </div>
              <div className="linux-code" style={{ width: 170 }}>
                $ sam deploy --guided
              </div>
            </div>
          </div>
          <div>
            <div className="deploy-item">
              <div className="item-text">
                <div className="title">{t("solution.cognito.deploy.item3.title")}</div>
                <div className="item-list">
                  <div className="list-icon">
                    <i className="icon authing-icon authing-configuration"></i>
                  </div>
                  <div className="list-text">
                    <div className="label">{t("solution.cognito.deploy.item3.config")}</div>
                    <div className="text">{t("solution.cognito.deploy.item3.configTip")}</div>
                  </div>
                </div>
                <div className="item-list">
                  <div className="list-icon">
                    <i className="icon authing-icon authing-Url"></i>
                  </div>
                  <div className="list-text">
                    <div className="label">{t("solution.cognito.deploy.item3.provider")}</div>
                    <div className="text">
                      {t("solution.cognito.deploy.item3.providerTip")}
                      {/* <span style={{ margin: "0px 4px" }}>
                        <Link
                          href="https://aws-oidc-demo-implicitflow.authing.cn/oidc"
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {t("solution.cognito.deploy.item3.demoLink")}
                        </Link>
                      </span> */}
                    </div>
                  </div>
                </div>
                <div className="item-list">
                  <div className="list-icon">
                    <i className="icon authing-icon authing-ID"></i>
                  </div>
                  <div className="list-text">
                    <div className="label">{t("solution.cognito.deploy.item3.audience")}</div>
                    <div className="text">{t("solution.cognito.deploy.item3.audienceTip")}</div>
                  </div>
                </div>
                <div className="item-list">
                  <div className="list-icon">
                    <i className="icon authing-icon authing-file"></i>
                  </div>
                  <div className="list-text">
                    <div className="label">{t("solution.cognito.deploy.item3.doc")}</div>
                    <div className="text">
                      {t("solution.cognito.deploy.item3.docTip")}
                      <span style={{ margin: "0px 4px" }}>
                        <Link
                          href="https://docs.aws.amazon.com/IAM/latest/UserGuide/id_roles_providers_create_oidc.html"
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {t("solution.cognito.deploy.item3.docLink")}
                        </Link>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="item-list">
                  <div className="list-icon">
                    <i className="icon authing-icon authing-configuration"></i>
                  </div>
                  <div className="list-text">
                    <div className="label">{t("solution.cognito.deploy.item3.configIdentity")}</div>
                    <div className="text">{t("solution.cognito.deploy.item3.configIdentityTip")}</div>
                  </div>
                </div>
                <div className="item-list">
                  <div className="list-icon">
                    <i className="icon authing-icon authing-developer-fill"></i>
                  </div>
                  <div className="list-text">
                    <div className="label">{t("solution.cognito.deploy.item3.authenticated")}</div>
                    <div className="text">{t("solution.cognito.deploy.item3.authenticatedTip")}</div>
                  </div>
                </div>
              </div>
              <div>
                <div className="item-img" style={{ width: 640 }}>
                  <img
                    src="//files.authing.co/authing-website/solution-cognito-identity-summary.png"
                    alt="authing cognito identity"
                  />
                </div>
                <div style={{ textAlign: "center", color: "#999999", fontSize: 14, margin: "18px 0px" }}>
                  {t("solution.cognito.deploy.item3.imgText")}
                </div>
                <div className="item-img" style={{ width: 640 }}>
                  <img
                    src="//files.authing.co/authing-website/solution-cognito-identity-openid.png"
                    alt="authing cognito deploy"
                  />
                </div>
              </div>
            </div>
            <div style={{ marginBottom: 70, color: "#666", lineHeight: "28px" }}>
              {t("solution.cognito.deploy.item3.subtitle")}
            </div>
          </div>
          <div className="deploy-item">
            <div className="item-img">
              <img src="//files.authing.co/authing-website/solution-cognito-web.png" alt="authing cognito deploy" />
            </div>
            <div className="item-text" style={{ width: "540px" }}>
              <div className="title">{t("solution.cognito.deploy.item4.title")}</div>
              <div className="descript-title">{t("solution.cognito.deploy.item4.subtitleTitle")}</div>
              <Link
                href="https://github.com/aws-samples/aws-authing-demo/tree/master/frontend"
                rel="noopener noreferrer"
                target="_blank"
              >
                https://github.com/aws-samples/aws-authing-demo/tree/master/frontend
              </Link>
              <div className="descript" style={{ marginTop: 10 }}>
                {t("solution.cognito.deploy.item4.subtitle")}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
